(function () {
  var bar = document.querySelector('[data-sv-sticky-atc]');
  var buybox = document.querySelector('[data-sv-buybox]');
  if (!bar || !buybox) return;

  var ctaEl = document.querySelector('.sv-buybox__cta');
  var pillsContainer = buybox.querySelector('[data-sv-buybox-pills]');
  var requiresSelection = buybox.getAttribute('data-requires-selection') === 'true';

  var priceEl = bar.querySelector('[data-sv-sticky-atc-price]');
  var compareEl = bar.querySelector('[data-sv-sticky-atc-compare-price]');
  var button = bar.querySelector('[data-sv-sticky-atc-button]');

  // sv:variant-change only ever fires from an explicit pill tap in
  // sv-product-buybox.js, so receiving it at all is proof of explicit selection —
  // no need to duplicate that tracking here.
  var explicitlySelected = !requiresSelection;

  function selectedLabel() {
    var selected = pillsContainer ? pillsContainer.querySelector('.sv-pill--selected') : null;
    return selected ? selected.textContent.trim() : null;
  }

  function syncButtonLabel() {
    if (requiresSelection && !explicitlySelected) {
      button.textContent = 'Select size';
      return;
    }
    var label = selectedLabel();
    button.textContent = label ? 'Add to cart · ' + label : 'Add to cart';
  }

  function syncPrice() {
    var sourcePrice = buybox.querySelector('[data-sv-buybox-price]');
    var sourceCompare = buybox.querySelector('[data-sv-buybox-compare-price]');
    if (priceEl && sourcePrice) priceEl.textContent = sourcePrice.textContent.trim();
    if (compareEl && sourceCompare) {
      compareEl.textContent = sourceCompare.textContent.trim();
      compareEl.hidden = sourceCompare.hidden;
    }
  }

  buybox.addEventListener('sv:variant-change', function () {
    explicitlySelected = true;
    syncPrice();
    syncButtonLabel();
  });

  syncPrice();
  syncButtonLabel();

  if (ctaEl && 'IntersectionObserver' in window) {
    var observer = new IntersectionObserver(
      function (entries) {
        var entry = entries[0];
        // Visible only once the CTA has scrolled above the viewport (top < 0) —
        // not before the shopper has scrolled down to it in the first place.
        bar.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
      },
      { threshold: 0 }
    );
    observer.observe(ctaEl);
  }

  function updateHeaderCartCount() {
    fetch('/cart.js')
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        var cartLink = document.querySelector('.sv-header__icon[aria-label="Cart"]');
        if (!cartLink) return;
        var countEl = cartLink.querySelector('.sv-header__cart-count');
        if (cart.item_count > 0) {
          if (!countEl) {
            countEl = document.createElement('span');
            countEl.className = 'sv-header__cart-count';
            cartLink.appendChild(countEl);
          }
          countEl.textContent = cart.item_count;
        }
      });
  }

  button.addEventListener('click', function () {
    if (requiresSelection && !explicitlySelected) {
      pillsContainer.scrollIntoView({ behavior: 'smooth', block: 'center' });
      pillsContainer.classList.add('sv-pulse');
      setTimeout(function () {
        pillsContainer.classList.remove('sv-pulse');
      }, 700);
      return;
    }

    var variantId = buybox.getAttribute('data-selected-variant-id');
    var originalText = button.textContent;
    button.disabled = true;
    button.textContent = 'Adding…';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Could not add to cart.');
        return response.json();
      })
      .then(function () {
        button.textContent = 'Added to cart ✓';
        updateHeaderCartCount();
        document.dispatchEvent(new CustomEvent('sv:cart:updated'));
        setTimeout(function () {
          button.textContent = originalText;
          button.disabled = false;
        }, 1500);
      })
      .catch(function () {
        button.textContent = originalText;
        button.disabled = false;
      });
  });
})();
